export const START_SENTRY_TRANSACTION = 'sentry::START_SENTRY_TRANSACTION';
export const END_SENTRY_TRANSACTION = 'sentry::END_SENTRY_TRANSACTION';

export enum SENTRY_TRANSACTIONS {
    AppStartToWelcomePage = 'AppStartToWelcomePage',
    AppStartToProfileSelection = 'AppStartToProfileSelection',
    MainPageRendering = 'MainPageRendering',
    PageNavigationHome = 'PageNavigationHome',
    PageNavigationEPG = 'PageNavigationEPG',
    PageNavigationOnDemand = 'PageNavigationOnDemand',
    PageNavigationRecordings = 'PageNavigationRecordings',
    ModularPageRenderingHome = 'ModularPageRenderingHome',
    ModularPageRenderingOnDemand = 'ModularPageRenderingOnDemand',
    ModularPageRenderingRecordings = 'ModularPageRenderingRecordings',
    CollectionPageRendering = 'CollectionPageRendering',
    SearchAction = 'SearchAction',
    DetailPageRendering = 'DetailPageRendering',
    ShowTVGuide = 'ShowTVGuide',
    ChannelTune = 'ChannelTune',
    CatchupPlaybackTime = 'CatchupPlaybackTime',
    VODPlaybackTime = 'VODPlaybackTime',
    RestartPlayback = 'RestartPlayback',
    JumpToLive = 'JumpToLive',
    ResumeFromPause = 'ResumeFromPause',
}
